class OurVisionModel {
	title;
	description;
	image;

	constructor({
		 title = '', description = '', image = '',
	}) {
		this.title = title;
		this.description = description;
		this.image = image;
	}
}

export default OurVisionModel;
